import { render, staticRenderFns } from "./BHLensing.vue?vue&type=template&id=0cd48243"
import script from "./BHLensing.vue?vue&type=script&lang=js"
export * from "./BHLensing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports